import Api from '@/api/index';

const Deposit = {
  namespaced: true,
  state: {
    allDeposits: [],
    statusByTitle:{}
  },
  getters: {
    
  },

  mutations: {
    setAllDeposits(state, deposit) {
      state.allDeposits = [...deposit]
    }

    // this.status_missed_id = state.allDeposits.find(s=>s.title == 'Missed').id
    // this.status_bacon_id = state.allDeposits.find(s=>s.title == 'Bacon').id
  },

  actions: {
    index(context, filters) {
      return Api.Deposit.index(filters).then(r => r.data).then(r => {
        context.commit('setAllDeposits', r.data)
        return true
      }).catch(err => {
        console.log(err)
        throw Error(err)
      })
    }
  }

};

export default Deposit;
